import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { APP_ROUTE } from 'app/app-routing.constant';
import { AuthenticationService, PermissionsService, UserRole } from 'app/core/authentication';
import { DefaultPageRouteService, RouterService } from 'app/core/navigation';

@UntilDestroy()
@Component({
  selector: 'kh-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less'],
  standalone: false
})
export class PageNotFoundComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private permissionsService = inject(PermissionsService);
  private readonly router = inject(RouterService);
  private readonly defaultRoutingService = inject(DefaultPageRouteService);

  public isLoading = true;
  public isLoggedIn = false;

  public ngOnInit() {
    this.authService.isAuthorized()
      .pipe(untilDestroyed(this))
      .subscribe((isAuthorized) => {
        if (isAuthorized && this.permissionsService.hasOnlyRole(UserRole.student)) {
        // go to student not found if they are only a student
          this.router.navigate(APP_ROUTE.STUDENT.PAGE_NOT_FOUND.route()).catch((error: unknown) => console.error(error));
          return;
        }
        this.isLoggedIn = isAuthorized;
        this.isLoading = false;
      });
  }

  public navigateToHome() {
    this.defaultRoutingService.routeToDefaultPage().catch((error: unknown) => console.error(error));
  }
}
